"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reducers = _interopRequireDefault(require("pricing-pages-unified-ui/reducers"));

var _sentryMiddleware = _interopRequireDefault(require("pricing-pages-unified-ui/utils/sentryMiddleware"));

//import { routerMiddleware } from 'react-router-redux';
//const middleware = [thunk, routerMiddleware(browserHistory)];
var middleware = [_reduxThunk.default, _sentryMiddleware.default];
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(void 0, middleware))(_redux.createStore);
var initialState = {};
var store = createStoreWithMiddleware(_reducers.default, initialState);
var _default = store;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/store.js
// module id = 513
// module chunks = 5 6